import * as React from 'react';
import {
    IFilter,
    actions as containersActions
} from 'services/containers/containers-service';
import { Filters, AutoScrollbars } from 'components';
import { SITE_TYPE_CUSTOM_FILTER_ID } from 'services/omjs/omjs-service';
import { getOperationData } from 'selectors';

export interface ITabAdditionalProps {
    filters: IFilter[];
    AREA_CATEGORY_FILTER_ID?: number;
    OWNERSHIP_TYPE_FILTER_ID?: number;
    POWERS_FILTER_ID?: number
}
export interface ITabAdditionalState {}

class TabAdditionalComponent extends React.Component<ITabAdditionalProps, ITabAdditionalState> {
    constructor(props: ITabAdditionalProps) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
    }

    componentDidMount() {
        const ids = [ 1338, 1337, 1336 ];
        let containers = getOperationData(false, 'CONTAINERS').filter(cont => ids.includes(cont.id));
        let filter = this.props.filters.find(f => f.id === -1000);

        if (filter.value !== null) {
            let filterValue = [];
            containers.forEach(cont => {
                if (cont.selected && filter.value.includes(cont.name)) {
                    filterValue.push(cont.name);
                }
            });

            containersActions.setFilter({
                code: 'plots',
                id: -1000,
                value: filterValue
            });
        }
    }

    onFilterChange(filter_id: number, filter_value: any) {
        if (filter_id === -1000 && filter_value !== null) {
            filter_value.forEach(val => {
                switch (val) {
                    case 'Предложения для девелоперов':
                        containersActions.setContainerSelected({ id_or_code: 1338, selected: true });
                        break;
                    case 'Brownfield':
                        containersActions.setContainerSelected({ id_or_code: 1337, selected: true });
                        break;
                    case 'Greenfield':
                        containersActions.setContainerSelected({ id_or_code: 1336, selected: true });
                        break;
                    default: break;
                }
            });
        }
        containersActions.setFilter({
            code: 'plots',
            id: filter_id,
            value: filter_value
        });
    }

    private renderFilterComponentById<T extends React.FC>(
        filter_id: number,
        rest_props: Partial<React.ComponentProps<T>> = {}
    ) {
        let filter = this.props.filters.find(f => f.id === filter_id);
        if (!filter) return null;
        let FilterComponent = Filters[filter.type];
        return (
            <FilterComponent
                filter={filter}
                {...rest_props}
            />
        );
    }

    render() {
        const {
            /** Категория земель */
            AREA_CATEGORY_FILTER_ID = 23,
            /** Форма собственности */
            OWNERSHIP_TYPE_FILTER_ID = 25,
            /** Питание */
            POWERS_FILTER_ID = 57
        } = this.props;
        return (
            <div className='additional-tab-wrapper'>
                <AutoScrollbars>
                    <div className="additional-filters-wrapper">
                        <div className="left-filters">
                            {this.renderFilterComponentById<typeof Filters['list_text']>(AREA_CATEGORY_FILTER_ID, {
                                onFilterChange: this.onFilterChange
                            })}
                        </div>
                        <div className="right-filters">
                            {this.renderFilterComponentById<typeof Filters['list_text']>(SITE_TYPE_CUSTOM_FILTER_ID, {
                                onFilterChange: this.onFilterChange
                            })}

                            {this.renderFilterComponentById<typeof Filters['list_text']>(OWNERSHIP_TYPE_FILTER_ID, {
                                onFilterChange: this.onFilterChange
                            })}
                        </div>
                    </div>
                </AutoScrollbars>
            </div>
        );
    }
}

export const TabAdditional = TabAdditionalComponent;
